import { RidangoReduxAction } from '@ridango/core';
import { tassign } from 'tassign';

import { AuthParametersActions } from './auth-parameters.actions';


export interface AuthParametersState {
    callback: string;
}

export const AUTH_PARAMETERS_INITIAL_STATE: AuthParametersState = {
    callback: null,
};

export function authParametersReducer(state: AuthParametersState = AUTH_PARAMETERS_INITIAL_STATE, action: RidangoReduxAction): AuthParametersState {
    switch (action.type) {

        case AuthParametersActions.SET_CALLBACK:
            return {
                ...state,
                callback: action.payload,
            };

        case AuthParametersActions.RESET:
            return tassign(state, AUTH_PARAMETERS_INITIAL_STATE);
    }

    return state;
}
